import { textStyleKeys, textStyles } from '@mangovoice/design-system/textStyles'

import { tokenVar } from '../../utils/designTokens'
import {
  createMultiStyleConfigHelpers,
  type MultiStyleType,
} from './styleHelpers'
import { mergeMultiStyleConfig } from './styleHelpers'

export const dropdownStyleParts = [
  'container',
  'menuButton',
  'placeholderText',
  'defaultText',
  'icon',
] as const

const helpers = createMultiStyleConfigHelpers(dropdownStyleParts)

export const DropdownStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      height: 'full',
      alignContent: 'center',
      position: 'relative',
    },
    menuButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      cursor: 'pointer',
      backgroundColor: 'bg.subtle',
      minHeight: '2.5rem',
      height: 'fit-content',
      width: '100%',
      paddingRight: '0.75rem',
      gap: '0.5rem',
      borderColor: 'border.default',
      borderStyle: 'solid',
      borderWidth: '1px',
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: 'bg.default',
        borderColor: 'border.default',
      },
      _active: {
        backgroundColor: 'bg.default',
        borderColor: 'border.default',
        boxShadow: tokenVar('shadows.focus'),
      },
    },
    defaultText: {
      paddingLeft: '0.75rem',
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.default',
      userSelect: 'none',
    },
    placeholderText: {
      paddingLeft: '0.75rem',
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.muted',
    },
    icon: {
      boxSize: '12px',
      color: 'fg.subtle',
    },
  },
})

export const useDropdownStyles = () =>
  mergeMultiStyleConfig(DropdownStyle) as MultiStyleType<
    typeof dropdownStyleParts
  >
